import { Droplets, CarFront, Zap, Wind } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal, Eyebrow } from "./Reveal";
import { NaturAirText } from "./NaturAirText";

export const Specs = () => {
  const { t } = useLanguage();

  const specs = [
    { icon: Droplets, title: t.spec_well_t, desc: t.spec_well_d, testid: "specs-private-well" },
    { icon: CarFront, title: t.spec_garage_t, desc: t.spec_garage_d, testid: "specs-garage" },
    { icon: Zap, title: t.spec_energy_t, desc: t.spec_energy_d, testid: "specs-electricity-fiber" },
    { icon: Wind, title: t.spec_air_t, desc: t.spec_air_d, testid: "specs-natur-air-purifiers", naturAir: true },
  ];

  return (
    <section data-testid="specs-section" className="relative py-28 sm:py-36 bg-[#070707] border-y border-[rgba(197,160,89,0.12)]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center">
          <Eyebrow>{t.specs_eyebrow}</Eyebrow>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#F3E5AB] leading-tight">{t.specs_title}</h2>
          <p className="mt-5 max-w-xl mx-auto text-[#9C9488] font-light leading-relaxed">{t.specs_sub}</p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {specs.map((s, i) => (
            <Reveal key={s.testid} delay={i * 0.1}>
              <div
                data-testid={s.testid}
                className="group h-full p-8 bg-[#0C0C0C] border border-[rgba(197,160,89,0.18)] hover:border-[rgba(197,160,89,0.5)] hover:-translate-y-1 hover:shadow-[0_24px_60px_rgba(197,160,89,0.08)] transition-all duration-500"
              >
                <div className="w-12 h-12 flex items-center justify-center border border-[rgba(197,160,89,0.4)] text-[#C5A059] group-hover:bg-[rgba(197,160,89,0.1)] transition-colors duration-500">
                  <s.icon size={20} strokeWidth={1.5} />
                </div>
                <h3 className="mt-6 font-serif text-xl text-[#EBD5B3]">
                  {s.naturAir ? <NaturAirText text={s.title} testid="specs-air-title" /> : s.title}
                </h3>
                <p className="mt-3 text-sm text-[#9C9488] font-light leading-relaxed">
                  {s.naturAir ? <NaturAirText text={s.desc} testid="specs-air-desc" /> : s.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
